import type { OrderDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Button, ContentCard, detailListStyles as styles } from '@/shared/ui';

interface OrderCustomerInfoProps {
  readonly order: OrderDetail;
  readonly onQuoteOpen: (quoteRequestId: string) => void;
}

/** 고객 정보 — 회사·단체·담당자·보존된 이메일. 휴대폰은 접속기록이 남는 견적 상세에서만 본다. */
export const OrderCustomerInfo = ({ order, onQuoteOpen }: OrderCustomerInfoProps): ReactElement => (
  <ContentCard title="고객 정보">
    <dl className={styles.list}>
      <dt className={styles.term}>회사·단체</dt>
      <dd>{order.companyName ?? <span className={styles.empty}>—</span>}</dd>
      <dt className={styles.term}>담당자</dt>
      <dd>{order.contactName}</dd>
      <dt className={styles.term}>이메일</dt>
      <dd>{order.customerEmail ?? <span className={styles.empty}>보존된 이메일 없음</span>}</dd>
    </dl>
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="mt-5"
      onClick={() => onQuoteOpen(order.quoteRequestId)}
    >
      견적 상세에서 휴대폰 보기
    </Button>
  </ContentCard>
);
